import { render, staticRenderFns } from "./FormRulesTipsPrudence.vue?vue&type=template&id=1eef4862"
import script from "./FormRulesTipsPrudence.vue?vue&type=script&lang=js"
export * from "./FormRulesTipsPrudence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports